import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material'
import { FooterCall, logoFacebook, logoInstagram, logoTiktok } from 'assets'
import { BiosferaSolutions, CardFormContact } from 'components'
import { COLORS, NAV_ITEMS_CONST } from 'const'
import { motion } from 'framer-motion'
import { useContactForm, UseContactFormHook, useDataLanding } from 'hooks'
import {
  captionTextStyle,
  container,
  containerSectionFooter,
  containerVariants,
  footerContentContainer,
  footerFormContainer,
  footerImage,
  footerMainContainer,
  normalTextStyle,
  titleTextStyle,
} from 'styles'

const socialNetwoks = [
  {
    src: logoTiktok,
    link: 'https://vt.tiktok.com/ZS96wQM7d7r9v-7fbVF/',
  },
  {
    src: logoFacebook,
    link: 'https://www.facebook.com/share/1TdYVRmgyq/',
  },
  {
    src: logoInstagram,
    link: 'https://www.instagram.com/nunakeyapp?igsh=MXJtZW02d2I5azRrOA==',
  },
]

export const FooterSection = () => {
  const useContactFormHook: UseContactFormHook = useContactForm()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { content } = useDataLanding()
  const date = new Date()

  return (
    <>
      <Box sx={containerSectionFooter} id="footerLanding">
        <Box
          sx={container}
          component={motion.div}
          initial="offscreen"
          whileInView="onscreen"
          variants={containerVariants}
          viewport={{ once: true }}
        >
          <Box sx={footerMainContainer}>
            <Box sx={footerContentContainer}>
              <Box component="img" src={FooterCall} alt="Footer Call" sx={footerImage} />
              <Typography
                variant="h3"
                sx={{
                  ...titleTextStyle,
                  fontWeight: 400,
                  textAlign: { xs: 'center', md: 'left' },
                  my: { xs: 2, lg: 5 },
                }}
              >
                {content?.footer?.title || 'Contáctanos'}
              </Typography>
              <Typography
                variant="body2"
                sx={{ ...normalTextStyle, width: { xs: '100%', lg: '80%' } }}
              >
                {content?.footer?.description ||
                  'No te quedes con dudas, llena el formulario y uno de nuestros ejecutivos se pondrá en contacto contigo.'}
              </Typography>
            </Box>
            <Box sx={footerFormContainer}>
              <CardFormContact contactFormHook={useContactFormHook} />
            </Box>
          </Box>
        </Box>
        <Divider variant="fullWidth" sx={{ borderColor: '#ffffffff' }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'center', md: 'flex-start' },
            gap: { xs: 2, md: 5, lg: 10 },
            my: { xs: 5, lg: 10 },
          }}
          component={motion.div}
          initial="offscreen"
          whileInView="onscreen"
          variants={containerVariants}
          viewport={{ once: true }}
        >
          {NAV_ITEMS_CONST.map((item) => (
            <Button
              key={item.targetId}
              sx={{
                ...captionTextStyle,
                color: 'white',
                fontFamily: 'Work Sans',
                fontWeight: 400,
              }}
              onClick={() => {
                const anchor = document.querySelector(item.targetId!)
                anchor?.scrollIntoView({ behavior: 'smooth' })
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>

        <Divider variant="fullWidth" sx={{ borderColor: COLORS.text.white }} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: {
              xs: 'center',
              sm: 'space-between',
              md: 'space-between',
            },
            alignItems: 'center',
            flexWrap: 'wrap',
            my: { xs: 5, lg: 10 },
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 2,
              mb: { xs: 5 },
              alignItems: 'center',
            }}
          >
            <Typography sx={captionTextStyle}>SÍGUENOS EN: </Typography>

            <Box sx={{ display: 'flex', gap: { xs: 2, lg: 3 }, alignItems: 'center' }}>
              {socialNetwoks.map((item) => (
                <Box
                  key={item.src}
                  component={'img'}
                  src={item.src}
                  onClick={() => {
                    window.open(item.link, '_blank')
                  }}
                  sx={{
                    width: {
                      xs: 20,
                      sm: 20,
                      md: 20,
                      lg: 25,
                    },
                    height: {
                      xs: 20,
                      sm: 20,
                      md: 20,
                      lg: 25,
                    },
                    ':hover': {
                      cursor: 'pointer',
                    },
                  }}
                />
              ))}
            </Box>
          </Box>

          {isMobile && (
            <Divider variant="fullWidth" sx={{ width: '100%', borderColor: COLORS.text.white }} />
          )}

          <BiosferaSolutions />
          <Box>
            <Typography
              sx={{
                ...captionTextStyle,
                fontFamily: 'Work Sans',
                textAlign: 'center',
                color: 'white',
                display: { xs: 'none', md: 'block' },
              }}
            >
              ©{date.getFullYear()} - Biosferasoft | All rights reserved
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  )
}
